import type { ReactionOptions } from 'stream-chat-react';

export enum ReactionType {
  like = 'like',
  dislike = 'sad',
}

export const customReactions: ReactionOptions = [
  {
    type: ReactionType.like,
    name: 'Like',
    Component: () => (
      <span role="img" aria-label="Like">
        👍
      </span>
    ),
  },
  {
    type: ReactionType.dislike,
    name: 'Dislike',
    Component: () => (
      <span role="img" aria-label="Dislike">
        👎
      </span>
    ),
  },
];
